module.exports = __webpack_public_path__ + "img/finished.52bed5b0.svg";